export class TaskBarData{
    countOfStops = 0;
    countOfAssigned = 0;
    startedTasksArray = [];
    assignedTasksArray = [];
    hasPassengers = false;
    passengerCountInVan = 0;
    passengerCountNotInVan = 0;
    plannedCompleteTime = null;
    dueTime = null;
}